import angular from 'angular';

(function () {
    'use strict';

    var kissExportComponent = {
        controller: 'KissExportCtrl as vm',
        templateUrl: require('./export.component.html'),
        bindings: {
            id: '<',
            searchFilter: '@',
            headerCols: '<',
            modelType: '@',
            isAvailableData: '<',
        },
    };
    angular.module('app.core').component('kissExportComponent', kissExportComponent);

    angular.module('app.core').controller('KissExportCtrl', KissExportCtrl);

    KissExportCtrl.$inject = ['CONF', '$cookies', 'XSRF_TOKEN'];
    function KissExportCtrl(CONF, $cookies, XSRF_TOKEN) {
        var vm = this;

        vm.exportUrl = '';
        vm.$onInit = onInit;
        vm.getFilter = getFilter;

        function onInit() {
            vm.csrf = $cookies.get(XSRF_TOKEN);
            vm.exportUrl = CONF.apiContext + CONF.apiBaseUrl + '/v1/utils/export';
        }

        function getFilter() {
            var filter = {
                id: vm.id,
                headerCols: vm.headerCols,
                filter: vm.searchFilter,
                format: 'csv',
                modelType: vm.modelType,
                locale: 'fr',
            };
            return filter;
        }
    }
})();
